import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWhyChoose } from "../whyChooseModal";

export const getAllWhyChoose = createAsyncThunk(
  "WhyChoose/FindAllWhyChoose",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhyChoose/FindAllWhyChoose`,
        {
          WhyChooseTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WhyChoose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWhyChoose = createAsyncThunk(
  "WhyChoose/InsertWhyChoose",
  async (WhyChooseData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhyChoose/InsertWhyChoose`,
        WhyChooseData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating WhyChoose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWhyChoose = createAsyncThunk(
  "WhyChoose/UpdateWhyChoose",
  async (WhyChooseData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhyChoose/UpdateWhyChoose`,
        WhyChooseData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating WhyChoose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWhyChoose = createAsyncThunk(
  "WhyChoose/DeleteWhyChoose",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhyChoose/DeleteWhyChoose`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting WhyChoose :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWhyChooseByID = createAsyncThunk(
  "WhyChoose/FindByIDWhyChoose",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhyChoose/FindByIDWhyChoose`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceID: result.ServiceID ? +result.ServiceID : "",
        Title: result.Title ? result.Title : "",
        Subtitle: result.Subtitle ? result.Subtitle : "",
        Description: result.Description ? result.Description : "",
        IsActive: result.IsActive ? 1 : 2,
      } as IWhyChoose;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching WhyChoose :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveWhyChoose = createAsyncThunk(
  "WhyChoose/FindAllActiveWhyChoose",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WhyChoose/FindAllActiveWhyChoose`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WhyChoose:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveWhyChoose = createAsyncThunk(
  "WhyChoose/ActiveInActiveWhyChoose",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhyChoose/ActiveInActiveWhyChoose`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive WhyChoose :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const WhyChooseDetailsImageUpload = createAsyncThunk(
  "WhyChoose/WhyChooseImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WhyChoose/WhyChooseImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload WhyChoose Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
